const prefix = '[Locations]';

export class LoadLocations {
    static readonly type = `${prefix} Load`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreLocations {
    static readonly type = `${prefix} Load More`;
}

export class LoadAllLocations {
    static readonly type = `${prefix} Load All`;
}
